import { render } from "./bkd-to-sti.vue?vue&type=template&id=18028572&ts=true"
import script from "./bkd-to-sti.vue?vue&type=script&lang=ts"
export * from "./bkd-to-sti.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__